type Props = {
  children: React.ReactNode;
};

export const ButtonLabel = ({ children }: Props): JSX.Element => (
  <p className={`m-0 font-firs text-[16px] font-medium tracking-[-0.22px]`}>
    {children}
  </p>
);
